import { render, staticRenderFns } from "./NavItem.vue?vue&type=template&id=0274ea08&"
import script from "./NavItem.vue?vue&type=script&lang=ts&setup=true&"
export * from "./NavItem.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports